import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["input", "toggleable"];

    connect() {
        this.toggle();
    }

    toggle() {
        if (this.inputTarget.checked) {
            this.show();
        } else {
            this.hide();
        }
    }

    show() {
        this.toggleableTargets.forEach((el) => {
            el.classList.remove("hidden");
        });
    }

    hide() {
        this.toggleableTargets.forEach((el) => {
            el.classList.add("hidden");
        });
    }
}
